import React from 'react'
import styles from './SmallTripList.scss'
import { Duration, Distance, Elevation } from 'common/units'
import cx from 'classnames'
import { CircleSpinner } from 'common/spinners'
import { ScrollTrigger } from 'common/ScrollTrigger'
import moment from 'moment'
import { Msg, commonNouns } from 'lib/localization'
import { FormattedMessage as T } from 'react-intl'

export class SmallTripList extends React.Component {
  loadNextPage = () => {
    const { participantId, nextPage, loadParticipantTrips } = this.props

    if (!nextPage || nextPage === 0) { return }
    if (participantId && nextPage !== -1) {
      loadParticipantTrips(participantId, nextPage)
    }
  }

  render () {
    const { trips, loading, showExclude, toggleExclude, nextPage } = this.props

    const spinner = <CircleSpinner size={25} centered className={styles.CircleSpinner} />

    const thead = (
      <thead className={styles.heading}>
        <tr>
          <th className={styles.thName}><Msg capitalized m={commonNouns.trips} values={{ count: 1 }} /></th>
          <th><Msg capitalized m={commonNouns.date} /></th>
          <th><Msg capitalized m={commonNouns.distance} /></th>
          <th><Msg capitalized m={commonNouns.elevation} /></th>
          <th><Msg capitalized m={commonNouns.movingTime} /></th>
          {showExclude && <th className={styles.thExclude} title='Exclude trip from goal progress calculations'><T id='SmallTripList.exclude' defaultMessage='Exclude' description='exclude a trip from goal calculations' /></th>}
        </tr>
      </thead>
    )

    // todo - prevent scrolling of body when end of this element is reached
    return (
      <div className={styles.scrollWrapper}>
        <table className={cx(styles.table, styles.fixedHeading)}>
          {thead}
        </table>
        <div className={styles.scrollWrapper}>
          <table className={cx(styles.table, styles.hideHeading)}>
            {thead}
            <tbody className={styles.body}>
              {trips.map(t => <TripListItem
                trip={t}
                key={t.get('id')}
                showExclude={showExclude}
                toggleExclude={toggleExclude} />)}
            </tbody>
          </table>
          {loading && spinner}
          {!loading && nextPage !== -1 && <ScrollTrigger key={nextPage} paddingFactor={0.5} onScrollIntoView={this.loadNextPage}>{spinner}</ScrollTrigger>}
        </div>
      </div>
    )
  }
}

// todo metric display support
export const TripListItem = ({ trip, extras, toggleExclude, showExclude }) => (
  <tr className={cx(styles.Item, trip.get('is_excluded') && styles.excluded)}>
    <td><a className={styles.tName} href={`/trips/${trip.get('id')}`} target='_blank'>{trip.get('name')}</a></td>
    <td>{moment(trip.get('departed_at')).format('MMM D YYYY')}</td>
    <td><Distance value={trip.get('distance')} /></td>
    <td><Elevation value={trip.get('elevation_gain')} /></td>
    <td>
      {(typeof trip.get('moving_time') === 'string')
        ? trip.get('moving_time')
        : <Duration value={trip.get('moving_time')} biggestUnits />}
    </td>
    {showExclude && <td>
      <input type='checkbox' checked={trip.get('is_excluded')} onChange={() => toggleExclude(trip.get('id'))} />
    </td>}
  </tr>
)
